import { Component, Element, Event, EventEmitter, h, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'form-validator',
  styleUrl: 'form-validator.css',
  shadow: false,
})
export class FormValidator {
  @Element() el: HTMLElement;

  @Event() formValid: EventEmitter<any>;
  @Event() formInvalid: EventEmitter<any>;
  @Event() submitForm: EventEmitter<any>;

  @Prop() idForm: string;

  private getFormFields(): HTMLInputElement[] {
    let form = document.querySelector(`#${this.idForm}`) as HTMLFormElement;
    if (!form) {
      console.error(`Form with id ${this.idForm} not found.`);
      return [];
    }
    /* return Array.from(this.el.querySelectorAll('input-text, input-number, input-file, input-switch, select-box, radio-check, textarea, datetime')) as any[]; */
    return Array.from(form.querySelectorAll('input, select, textarea')) as HTMLInputElement[];
  }

  @Listen('submit', { capture: true })
  handleSubmit(ev: Event) {
    ev.preventDefault();

    const fields = this.getFormFields();
    let isValid = true;
    const formData: Record<string, any> = {};
    const tabValidity: Record<string, boolean> = {};

    fields.forEach(field => {
      const tab = field.getAttribute('data-tab') || 'default';
      const validity = field.checkValidity();
      const errorContainerId = `${field.name}-error`;
      let errorContainer = this.el.querySelector(`#${errorContainerId}`) as HTMLElement;

      // Limpiar estilos y mensajes anteriores
      field.classList.remove('is-invalid', 'is-valid');
      if (errorContainer) {
        errorContainer.innerHTML = '';
      }

      if (!validity) {
        field.classList.add('is-invalid');
        if (!errorContainer) {
          // Crear el contenedor si no existe
          errorContainer = document.createElement('div');
          errorContainer.id = errorContainerId;
          errorContainer.className = 'invalid-feedback d-block mb-2 mt-0';
          field.insertAdjacentElement('afterend', errorContainer);
        }
        errorContainer.textContent = field.validationMessage;
        isValid = false;
        tabValidity[tab] = false;
      } else {
        field.classList.add('is-valid');
        formData[field.name] = field.value;
        // Si no hay error en esta tab aún, lo marcamos como válido (tentativamente)
        if (!(tab in tabValidity)) {
          tabValidity[tab] = true;
        }
      }
    });

    if (isValid) {
      this.formValid.emit(formData);
      console.log('Form data validation:', formData);
    } else {
      this.formInvalid.emit(tabValidity);
    }
  }

  render() {
    return (
      <form id={this.idForm} novalidate onSubmit={ev => this.handleSubmit(ev)}>
        <slot />
      </form>
    );
  }
}
